import { useState } from "react";
import { FileText, Plus, Users } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";

import useAppBarHeight from "../misc/useAppBarHeight";
import { EmptyState } from "../shared/EmptyState";
import { useIsMobile } from "@/hooks/use-mobile";
import { ContactCreateSheet } from "./ContactCreateSheet";
import { ContactImportDialog } from "./ContactImportButton";

// Sprint 7 T7.1.e — Empty state "vide total" pour la liste contacts.
// Cf maquette design/atomic-crm/contacts-app.jsx (.empty-state avec
// Icon.Users + "Pas encore de contacts" + 2 CTAs Add/Import).

export const ContactEmpty = () => {
  const appbarHeight = useAppBarHeight();
  const isMobile = useIsMobile();
  const [createOpen, setCreateOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);

  return (
    <>
      <ContactCreateSheet open={createOpen} onOpenChange={setCreateOpen} />
      <ContactImportDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
      />
      <div
        className="flex flex-col justify-center"
        style={{ minHeight: `calc(100dvh - ${appbarHeight}px)` }}
      >
        <EmptyState
          icon={<Users className="size-6" />}
          title="Pas encore de contacts"
          description="Commence à construire ton CRM en ajoutant tes leads. Tu peux les saisir un par un ou importer un fichier CSV depuis LinkedIn ou un autre outil."
          ctas={
            isMobile ? (
              <Button onClick={() => setCreateOpen(true)} className="gap-1.5">
                <Plus className="size-4" />
                Ajouter ton premier contact
              </Button>
            ) : (
              <>
                <Button asChild className="gap-1.5">
                  <Link to="/contacts/create">
                    <Plus className="size-4" />
                    Ajouter ton premier contact
                  </Link>
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  className="gap-1.5"
                  onClick={() => setImportOpen(true)}
                >
                  <FileText className="size-4" />
                  Importer un CSV
                </Button>
              </>
            )
          }
        />
      </div>
    </>
  );
};
